module.exports = __webpack_public_path__ + "media/images/ic-number-advisor-cc416ac301b9af2792f024b2fb7e6230.svg";